"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHARACTER_EYE_COLORS = exports.CHARACTER_SKIN_COLORS = exports.CHARACTER_HAIR_COLORS = void 0;
/**
 * Hair colors
 */
exports.CHARACTER_HAIR_COLORS = [
    "#473439",
    "#b2302e",
    "#cd6521",
    "#75565a",
    "#532b2e",
    "#7a4748",
    "#442a2a",
    "#623c2c",
    "#4e3532",
    "#3c2828",
    "#fccdc7",
    "#dc6052",
    "#c93a1c",
    "#b32010",
    "#463933",
    "#8b4c22",
    "#bb9d83",
    "#725242",
    "#b16c35",
    "#823917",
    "#edd1b7",
    "#c77e51",
    "#e2d0ba",
    "#c28060",
    "#c8baa3",
    "#7a5440",
    "#f3efe3",
    "#b9a29f",
    "#fbe5bb",
    "#daa178",
    "#fff7e1",
    "#dfb793",
    "#f9d3bd",
    "#fdfbef",
    "#ddcfbf",
    "#f7efc8",
    "#d1a158",
    "#d2edcb",
    "#6daf76",
    "#cde7e5",
    "#394a49",
    "#1c3036",
    "#389695",
    "#c2c7c8",
    "#869b9d",
    "#c7eaed",
    "#89d1db",
    "#427ab3",
    "#1c324f",
    "#12132c",
    "#324079",
    "#91a2a0",
    "#41809b",
    "#60899d",
    "#b5c5d7",
    "#505ea9",
    "#cfc9ed",
    "#816ab5",
    "#2c2636",
    "#246a89",
    "#584862",
    "#cdcfdc",
    "#dbd5e0",
    "#a98d9d",
    "#3b1b32",
    "#7c5173",
];
exports.CHARACTER_SKIN_COLORS = [
    "#FFCC99",
    "#FEB186",
    "#DFC183",
    "#CEAB69",
    "#B98865",
    "#AA724B",
    "#935D37",
    "#CBACA3",
    "#C0A183",
    "#C18E74",
    "#EBCDA8",
    "#CAA661",
    "#7B4B2A",
    "#573719",
    "#483728",
];
exports.CHARACTER_EYE_COLORS = [
    "#18100E",
    "#F8D26B",
    "#B1BCD5",
    "#949597",
    "#A7CEC6",
    "#7A888B",
    "#4E4D52",
    "#514E3C",
    "#866F3F",
    "#90524C",
    "#78471E",
    "#AAAC4F",
    "#56361B",
];
